var map = {
	"./ai/assets/favicon.ico": "ddbc",
	"./ai/assets/logo.svg": "0e37",
	"./ar/assets/favicon.ico": "7b8a",
	"./ar/assets/logo.svg": "45b5",
	"./dls-bs/assets/favicon.ico": "1eb4",
	"./dls-bs/assets/logo.svg": "e4f2",
	"./dls-sg/assets/favicon.ico": "6db4",
	"./dls-sg/assets/logo.svg": "b32c",
	"./dls/assets/favicon.ico": "2cf1",
	"./dls/assets/logo.svg": "27ea",
	"./ftone/assets/favicon.ico": "e23d",
	"./ftone/assets/logo.svg": "9618",
	"./ftw/assets/favicon.ico": "ee07",
	"./ftw/assets/logo.svg": "929c",
	"./hmb/assets/logo.svg": "c388",
	"./imag/assets/favicon.ico": "5bbc",
	"./imag/assets/logo.svg": "b805",
	"./izrb/assets/favicon.ico": "a1f6",
	"./izrb/assets/logo.svg": "b676",
	"./koeniz/assets/favicon.ico": "bff2",
	"./koeniz/assets/logo.svg": "f282",
	"./nidau/assets/logo.svg": "854d",
	"./ogg/assets/favicon.ico": "5c57",
	"./ogg/assets/logo.svg": "965f",
	"./phvs/assets/favicon.ico": "a288",
	"./phvs/assets/logo.svg": "3472",
	"./sg/assets/favicon.ico": "2b34",
	"./sg/assets/logo.svg": "965c",
	"./spdag-tr/assets/favicon.ico": "98c6",
	"./spdag-tr/assets/logo.svg": "2d4f",
	"./spdag/assets/favicon.ico": "6c92",
	"./spdag/assets/logo.svg": "a308",
	"./stzg/assets/favicon.ico": "009c",
	"./stzg/assets/logo.svg": "fa54",
	"./teamraum/assets/favicon.ico": "1736",
	"./teamraum/assets/logo.svg": "96aa",
	"./unilu/assets/favicon.ico": "24f0",
	"./unilu/assets/logo.svg": "02a1",
	"./vdf/assets/favicon.ico": "9cb4",
	"./vdf/assets/logo.svg": "7bcf",
	"./zg/assets/favicon.ico": "864d",
	"./zg/assets/logo.svg": "ee69"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e517";